import { api } from './auth.service';

// Equivale às funções TCQuery/TCSetField do ADVPL — toda comunicação
// com o backend para o módulo de usuários passa por aqui

const usuarioService = {

  // Listar todos os usuários
  listar: async () => {
    const res = await api.get('/usuarios');
    return res.data;
  },

  // r213: versão LEVE pra combos/citações. Bate em /usuarios/referencia —
  // liberado a QUALQUER autenticado, sem checagem de rotina. Devolve
  // id, nome, nome_amigavel, email, foto e label, escondendo o usuário de
  // sistema (admin@alphaerp.com.br). Aceita { q } pra autocomplete.
  listarReferencia: async (params = {}) => {
    const res = await api.get('/usuarios/referencia', { params });
    return res.data;
  },

  // Buscar um usuário pelo ID
  buscarPorId: async (id) => {
    const res = await api.get(`/usuarios/${id}`);
    return res.data;
  },

  // Incluir novo usuário
  incluir: async (dados) => {
    const res = await api.post('/usuarios', dados);
    return res.data;
  },

  // Alterar usuário existente
  alterar: async (id, dados) => {
    const res = await api.put(`/usuarios/${id}`, dados);
    return res.data;
  },

  // Bloquear / desbloquear usuário
  alterarStatus: async (id, status) => {
    const res = await api.patch(`/usuarios/${id}/status`, { status });
    return res.data;
  },

  // Resetar senha do usuário (gera nova senha e envia por e-mail)
  resetarSenha: async (id) => {
    const res = await api.post(`/usuarios/${id}/reset-senha`);
    return res.data;
  },

  // Listar grupos de acesso (para o combo do formulário)
  listarGrupos: async () => {
    const res = await api.get('/grupos-acesso');
    return res.data;
  },

  // r115: Upload de foto do usuário (multipart/form-data)
  uploadFoto: async (id, file, onProgress) => {
    const formData = new FormData();
    formData.append('arquivo', file);
    const res = await api.post(`/usuarios/${id}/foto`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      },
    });
    return res.data;   // { mensagem, foto: "/uploads/usuarios/..." }
  },

  // r115: Remover foto do usuário
  removerFoto: async (id) => {
    const res = await api.delete(`/usuarios/${id}/foto`);
    return res.data;
  },
};

export default usuarioService;
